import { EvaluateConsole } from './evaluate-record/EvaluateConsole'
import './evaluate-record/quickstart.css'

export function EvaluateRecordPage() {
  return (
    <div className="evaluate-quickstart">
      <EvaluateConsole />
    </div>
  )
}
